import O1HD from "../../engines/gameEngine";
import utilsView from "../../engines/libs/utilsView";
import { FileKind } from "../../modes/define/FileKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class archeryStartPage extends cc.Component {

    @property({type:cc.Node,tooltip:"对话节点"})
    chatNode:cc.Node = null;

    @property({type:cc.Node,tooltip:"按钮节点"})
    btnNode:cc.Node = null;

    start(): void {
        this.chatNode.scale = 0;
        cc.tween(this.chatNode).delay(1).to(0.2,{scale:1}).delay(1).call(()=>{
            this.btnNode.active = true;
        }).start();
    }

    canclick:boolean = true;

    onBtnSave(){
        if(!this.canclick){
            return;
        }
        this.canclick = false;
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let fun = (node:cc.Node)=>{
            this.closeThis();
        };
        utilsView.openPopupLayerTwo(
            FileKind.PrefabFilePath.archeryGameLayer,null,null,null,fun
        );
    }

    onBtnNotSave(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
    }

}
